/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SortingFieldEnum } from './SortingFieldEnum';
import {
    SortingFieldEnumFromJSON,
    SortingFieldEnumFromJSONTyped,
    SortingFieldEnumToJSON,
    SortingFieldEnumToJSONTyped,
} from './SortingFieldEnum';
import type { PersonTypeEnum } from './PersonTypeEnum';
import {
    PersonTypeEnumFromJSON,
    PersonTypeEnumFromJSONTyped,
    PersonTypeEnumToJSON,
    PersonTypeEnumToJSONTyped,
} from './PersonTypeEnum';

/**
 * 
 * @export
 * @interface SearchInsuredCommandDto
 */
export interface SearchInsuredCommandDto {
    /**
     * Search string for filtering results (maximum 100 characters)
     * @type {string}
     * @memberof SearchInsuredCommandDto
     */
    searchString?: string;
    /**
     * 
     * @type {PersonTypeEnum}
     * @memberof SearchInsuredCommandDto
     */
    personType?: PersonTypeEnum;
    /**
     * Page number for pagination (must be greater than 0)
     * @type {number}
     * @memberof SearchInsuredCommandDto
     */
    pageNumber?: number;
    /**
     * Number of items per page (between 1 and 100)
     * @type {number}
     * @memberof SearchInsuredCommandDto
     */
    pageSize?: number;
    /**
     * 
     * @type {SortingFieldEnum}
     * @memberof SearchInsuredCommandDto
     */
    sorting?: SortingFieldEnum;
    /**
     * Filter persons by plateforme (admin mode). When set, replaces the broker scope filter.
     * @type {string}
     * @memberof SearchInsuredCommandDto
     */
    plateformeId?: string;
}



/**
 * Check if a given object implements the SearchInsuredCommandDto interface.
 */
export function instanceOfSearchInsuredCommandDto(value: object): value is SearchInsuredCommandDto {
    return true;
}

export function SearchInsuredCommandDtoFromJSON(json: any): SearchInsuredCommandDto {
    return SearchInsuredCommandDtoFromJSONTyped(json, false);
}

export function SearchInsuredCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchInsuredCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'searchString': json['searchString'] == null ? undefined : json['searchString'],
        'personType': json['personType'] == null ? undefined : PersonTypeEnumFromJSON(json['personType']),
        'pageNumber': json['pageNumber'] == null ? undefined : json['pageNumber'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'sorting': json['sorting'] == null ? undefined : SortingFieldEnumFromJSON(json['sorting']),
        'plateformeId': json['plateformeId'] == null ? undefined : json['plateformeId'],
    };
}

export function SearchInsuredCommandDtoToJSON(json: any): SearchInsuredCommandDto {
    return SearchInsuredCommandDtoToJSONTyped(json, false);
}

export function SearchInsuredCommandDtoToJSONTyped(value?: SearchInsuredCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'searchString': value['searchString'],
        'personType': PersonTypeEnumToJSON(value['personType']),
        'pageNumber': value['pageNumber'],
        'pageSize': value['pageSize'],
        'sorting': SortingFieldEnumToJSON(value['sorting']),
        'plateformeId': value['plateformeId'],
    };
}

